import React, { useEffect, useRef } from 'react';
import {
  useInitialDataLoader,
  useListingStore,
} from '@brightmls/nextgen.lae.flc';
import { PreviewLoadedContentProps } from '../types';

const PreviewLoadedContent: React.FC<PreviewLoadedContentProps> = ({
  data,
  children,
}) => {
  const { loadInitialData } = useInitialDataLoader();
  const hasLoadedRef = useRef(false);

  useEffect(() => {
    if (data?.listing && !hasLoadedRef.current) {
      hasLoadedRef.current = true;
      loadInitialData(data.listing, { clearAll: true });
      // Lock the listing — preview is always read-only
      useListingStore.setState({ locked: true });
    }
  }, [data, loadInitialData]);

  return <>{children}</>;
};

export default PreviewLoadedContent;
